/**
 * 産廃回収詳細 運搬先事業場編集
 */
import Vue from 'vue'
import * as httpConst from '../../../../../../constants/httpConst'

const API_PATH = `${httpConst.DRIVER_ENDPOINT}/orders/accepts/collections`

const order_accept_collection_transport_location = {
  namespaced: true,
  actions: {
    /**
     * 編集データの取得
     * @param commit
     * @param order_id
     * @return {Promise<unknown>}
     */
    edit ({ commit }, { order_id }) {
      const api_path = `${API_PATH}/${order_id}/transport_locations/edit`
      return new Promise((resolve) => {
        Vue.$http.get(api_path).then(data => {
          resolve(data.content)
        })
      })
    },
    /**
     * 受注登録 更新
     * @param commit
     * @param order_id
     * @param params
     * @return {Promise<unknown>}
     */
    update ({ commit }, { order_id, params }) {
      return new Promise( ( resolve ) => {
        const api_path = `${API_PATH}/${order_id}/transport_locations`
        Vue.$http.put(api_path, params).then( data => {
          let content = data.content
          commit('snackbar/showInfo', { message: '登録しました' }, { root: true })
          resolve(content)
        } )
      })
    },
  },
}
export default order_accept_collection_transport_location
